import React from 'react';

const FeatureSection = () => {
  return (
    <section>
      <div className="container">
        <div className="row align-items-center justify-content-between">
          <div className="col-12 col-lg-6">
            <div className="row">
              <div className="col-md-6">
                <div className="p-4 rounded shadow">
                  <div className="bg-primary p-2 d-inline-block rounded">
                    <div className="f-icon-m text-white">
                      <i className="flaticon-lightbulb"></i>
                    </div>
                  </div>
                  <h5 className="mt-4 mb-3">Easy To Use</h5>
                  <p className="mb-0">
                    Taking design from EPICFINAL design and typography, contemporary page layouts.
                  </p>
                </div>
              </div>
              <div className="col-md-6 mt-5">
                <div className="p-4 rounded shadow">
                  <div className="bg-primary p-2 d-inline-block rounded">
                    <div className="f-icon-m text-white">
                      <i className="flaticon-migrating"></i>
                    </div>
                  </div>
                  <h5 className="mt-4 mb-3">Cloud Migration</h5>
                  <p className="mb-0">
                    Taking design from EPICFINAL design and typography, contemporary page layouts.
                  </p>
                </div>
              </div>
              <div className="col-md-6 mt-5 mt-md-0">
                <div className="p-4 rounded shadow">
                  <div className="bg-primary p-2 d-inline-block rounded">
                    <div className="f-icon-m text-white">
                      <i className="flaticon-graphs"></i>
                    </div>
                  </div>
                  <h5 className="mt-4 mb-3">Data Analysis</h5>
                  <p className="mb-0">
                    Taking design from EPICFINAL design and typography, contemporary page layouts.
                  </p>
                </div>
              </div>
              <div className="col-md-6 mt-5">
                <div className="p-4 rounded shadow">
                  <div className="bg-primary p-2 d-inline-block rounded">
                    <div className="f-icon-m text-white">
                      <i className="flaticon-3d-modeling"></i>
                    </div>
                  </div>
                  <h5 className="mt-4 mb-3">Software Design</h5>
                  <p className="mb-0">
                    Taking design from EPICFINAL design and typography, contemporary page layouts.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;
